// extracted by mini-css-extract-plugin
export var deleteModal = "_qv-0";